import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginTrackingApiService {
  constructor(private readonly http: HttpClient) {}

  trackLoginStep(payload: {
    session_id: string;
    stage: string;
    platform?: string | null;
    os_version?: string | null;
    model?: string | null;
    manufacturer?: string | null;
    app_version?: string | null;
    device_id?: string | null;
    message?: string | null;
    state_id?: string | null;
  }) {
    return this.http.post(
      `${environment.CREW_APP_BACKEND_API_BASE_URL}/login-tracking`,
      payload,
    );
  }
}
